import UtagHelper from 'utilities/utagHelper';
import cryptoJS from 'crypto-js';
import { recordPage, RELIABLE } from 'utilities/uTagging';
import { EVENT_SIGNATURE_KEY, ONBOARDING_SUCCESS, EVENT_ONBOARDING } from 'constants/uTagConstants/RAConstants';
import { PATH_SIGNATURE_KEY } from 'constants/uTagConstants/paths';
import { ORIGIN_BY_CHANNEL } from 'constants/uTagConstants/origin';
import { recordEventCustomOnly } from 'utilities/uTagging';
import { getGA4EventKeys } from 'utilities/ga4';

export const doTagPage = ({ userProfile }) => {
    const jointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
    const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
    const pageName = '/onboarding/step06a/signatureKey';
    const custom = {
        ...getGA4EventKeys({
            eventName: 'step_signatureKey',
            pageName,
            processDetail: 'signatureKey',
            onboardingType: userProfile.investmentType,
        }),
        tipoProceso: 'onboarding',
        pasoProceso: EVENT_SIGNATURE_KEY,
        identificadorOnboarding: docNumberEncrypted,
        processStep: 'step06a',
        onboardingR: userProfile.clientRisk || '',
        onboardingIdMethod: RELIABLE[userProfile.identityMethod],
        onboardingOrigin: ORIGIN_BY_CHANNEL[userProfile.channel],
    };

    recordPage(
        PATH_SIGNATURE_KEY,
        undefined,
        userProfile.userId,
        undefined,
        undefined,
        undefined,
        jointHolderInfo,
        undefined,
        undefined,
        userProfile.investmentType,
        custom
    );

    return pageName;
};

export const doTagSaveSignatureKeySuccess = ({ investmentType }) => {
    recordEventCustomOnly(
        {
            categoriaEvento: ONBOARDING_SUCCESS,
            accionEvento: PATH_SIGNATURE_KEY,
            etiquetaEvento: 'crea tu clave firma',
            tipoOnboarding: investmentType,
        },
        PATH_SIGNATURE_KEY
    );
};
export const doTagSignatureLeadScore = ({ score }) => {
    recordEventCustomOnly({
        action: 'success',
        component: 'onboarding',
        format: 'simulation-data',
        element: 'scoring',
        data: score,
    });
};

export const doTagContinueAction = () => {
    recordEventCustomOnly(
        {
            categoriaEvento: EVENT_ONBOARDING,
            accionEvento: EVENT_SIGNATURE_KEY,
            etiquetaEvento: 'continuar',
            event_name: 'event_success',
            action: 'success',
            format: 'steps',
            component: 'funnel',
            element: 'signatureKey',
        },
        PATH_SIGNATURE_KEY
    );
};

export const doTagCancelAction = () => {
    recordEventCustomOnly(
        {
            categoriaEvento: EVENT_ONBOARDING,
            accionEvento: EVENT_SIGNATURE_KEY,
            etiquetaEvento: 'salir',
        },
        PATH_SIGNATURE_KEY
    );
};
export const doTagInputAction = () => {
    recordEventCustomOnly(
        {
            categoriaEvento: EVENT_ONBOARDING,
            accionEvento: EVENT_SIGNATURE_KEY,
            etiquetaEvento: 'input',
        },
        PATH_SIGNATURE_KEY
    );
};

export const doTagMoreInfoAction = () => {
    recordEventCustomOnly(
        {
            categoriaEvento: EVENT_ONBOARDING,
            accionEvento: EVENT_SIGNATURE_KEY,
            etiquetaEvento: 'mas informacion',
        },
        PATH_SIGNATURE_KEY
    );
};

export const doTagTogglePasswordAction = () => {
    recordEventCustomOnly(
        {
            categoriaEvento: EVENT_ONBOARDING,
            accionEvento: EVENT_SIGNATURE_KEY,
            etiquetaEvento: 'mostrar clave',
        },
        PATH_SIGNATURE_KEY
    );
};
